import { Component, OnInit, OnDestroy, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { ObservableMedia, MediaChange } from '@angular/flex-layout';

import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators/takeUntil';

import { StudentCollegeInfo, StudentInfo } from '../../../services/application/application.service';
import { UserInfo } from '../../../services/user/user.service';
import { DialogService } from '../../../services/dialogs/dialogs.service';

@Component({
    selector: 'app-student-info',
    styleUrls: ['studentinfo.component.css'],
    templateUrl: 'studentinfo.component.html',
})
export class StudentInfoComponent implements OnInit, OnDestroy, OnChanges {
    private _subrelease: Subject<void> = new Subject<void>();

    @Input() SelectedStudent: StudentInfo;
    @Input() SelectedCollege: StudentCollegeInfo;
    @Input() User: UserInfo;

    @Output() update: EventEmitter<boolean> = new EventEmitter<boolean>();

    SmallDisplay: boolean;
    CollegeGPADisclaimer = `
        "Unweighted College GPA" is calculated based on the dual enrollment courses that a student has completed within DELTA.
    `;
    constructor(private mediaChange: ObservableMedia, private dialogService: DialogService) {}

    ngOnDestroy() {
        this._subrelease.next();
        this._subrelease.complete();
    }

    ngOnInit() {
        const self = this;

        self.SmallDisplay = self.mediaChange.isActive('xs') || self.mediaChange.isActive('sm');

        self.mediaChange
            .asObservable()
            .pipe(takeUntil(self._subrelease))
            .subscribe(media => {
                self.SmallDisplay = media.mqAlias === 'xs' || media.mqAlias === 'sm';
            });
    }

    ngOnChanges() {}

    // #region Update College Student ID Method

    UpdateCollegeStudentID() {
        this.update.emit(true);
    }

    // #endregion

    // #region Update College Student ID Method

    OpenGPADisclaimerDialog() {
        this.dialogService.OpenMessageBoxDialog({
            TitleText: 'Disclaimer',
            MessageText: `
                <strong>Unweighted College GPA</strong> is a GPA calculation based on the dual enrollment courses that a student has completed within DELTA. 
                A few disclaimers regarding this calculation:<br>
                <ul>
                    <li>This will only calculate courses that have been selected in DELTA, and will not account for 
                        other dual enrollment courses the student has completed outside of DELTA.
                    </li>
                    <li>This not indicative of the student's individual college GPA for any college.</li>
                    <li>Due to how this field is calculated, if any updates were made to a student's final grade for any DELTA dual enrollment course,
                        please allow up to 24 hours for those changes to be reflected in this calculation.</li>
            `,
            height: '450px',
        });
    }

    // #endregion

    
}



// WEBPACK FOOTER //
// ./src/app/ui/studentinfo/studentinfo.component.ts